import {dynamicTabConfig, staticTabConfig} from "@/components/layout/TabContentContainer.types.ts";
import {MaintenanceSchedule} from "@/lib/types/maintenance.ts";
import {MaintenanceDashboardTabs} from "@/pages/maintenance/maintenance-dashboard/MaintenanceDashboard.types.ts";
import {ActiveOccurrencesTab} from "@/pages/maintenance/maintenance-dashboard/tabs/active-occurrences/ActiveOccurrencesTab.tsx";
import {MaintenanceEventLogTab} from "@/pages/maintenance/maintenance-dashboard/tabs/schedule-eventlog/MaintenanceEventLogTab.tsx";
import {MaintenanceSchedulesTab} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/MaintenanceSchedulesTab.tsx";

export const StaticMaintenanceDashboardTabConfig: Record<
  MaintenanceDashboardTabs,
  staticTabConfig<void, MaintenanceSchedule[]>
> = {
  [MaintenanceDashboardTabs.ACTIVE]: {
    id: "active",
    title: "Active",
    html: () => <ActiveOccurrencesTab />,
  },
  [MaintenanceDashboardTabs.SCHEDULES]: {
    id: "schedules",
    title: "Schedules",
    html: () => <MaintenanceSchedulesTab />,
  },
  [MaintenanceDashboardTabs.EVENT_LOG]: {
    id: "event-log",
    title: "Event Log",
    html: () => <MaintenanceEventLogTab />,
  },
};

export const defaultMaintenanceDashboardConfig: Record<MaintenanceDashboardTabs, dynamicTabConfig> = {
  [MaintenanceDashboardTabs.ACTIVE]: {
    isVisible: true,
  },
  [MaintenanceDashboardTabs.SCHEDULES]: {
    isVisible: true,
  },
  [MaintenanceDashboardTabs.EVENT_LOG]: {
    isVisible: true,
  },
};
